import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";

class User {
    static changePassword (props) {
        App.log('USER.CHANGE_PASSWORD', App.LOG.FETCH, props);

        const body = {
            oldPassword: props.oldPassword,
            passWord: props.passWord,
            rePassword: props.rePassword,
        };

        return new Promise((resolve, reject) => {
            fetch(Api.USER.CHANGE_PASSWORD, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }

    static login (props) {
        App.log('USER.LOGIN', App.LOG.FETCH, props);

        const body = {
            userName: props.username,
            passWord: props.password
        };

        return new Promise((resolve, reject) => {
            fetch(Api.USER.LOGIN, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        const permissions = {};

                        for (const item of (result.objList[0].userAccessList || [])) {
                            if (!permissions[item.menuURL])
                                permissions[item.menuURL] = {};

                            for (const permission of item.userAccessActionList) {
                                permissions[item.menuURL][permission.actionEnName] = {
                                    id: permission.menuActionId,
                                    name: permission.actionEnName,//.split(/(?=[A-Z])/).join('_').toUpperCase(),
                                    text: permission.actionFaName
                                };
                            }
                        }

                        resolve({
                            ...result.objList[0],
                            save: props.save,
                            permissions
                        });
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.SERVER_ERROR);
            });
        });
    }
}

export default User;